import { fetchApi } from '@/config/axiosSetting.ts';

import {
  DownloadZipFileQueryResponseType,
  DownloadZipFileZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipFile/downloadZipFileQuery.type';

export const downloadZipFileQueryFunction = ({
  id,
}: DownloadZipFileZipType): Promise<DownloadZipFileQueryResponseType> =>
  fetchApi.get(`documents/${id}/file_document_zip/download/`);
